// client/src/components/common/LanguageSwitcher.js
import React, { useContext, useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { Translate as TranslateIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { LocaleContext } from '../../contexts/LocaleContext';

const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation();
  const { changeLanguage } = useContext(LocaleContext);
  const [anchorEl, setAnchorEl] = useState(null);
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const handleLanguageChange = (language) => {
    console.log('Language selected:', language);
    changeLanguage(language);
    handleClose();
  };
  
  return (
    <>
      <IconButton
        color="inherit"
        aria-controls="language-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <TranslateIcon />
      </IconButton>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem 
          onClick={() => handleLanguageChange('en')}
          selected={i18n.language === 'en'}
        >
          <ListItemText primary="English" />
        </MenuItem>
        <MenuItem 
          onClick={() => handleLanguageChange('ar')}
          selected={i18n.language === 'ar'}
        >
          <ListItemText primary="العربية" />
        </MenuItem>
      </Menu>
    </>
  );
};

export default LanguageSwitcher;